import React, { useEffect, useState } from "react";
import CText from "../../common/CText";
import { View,TouchableOpacity} from "react-native";
import CImage from "../../common/CImage";
import CView from "../../common/CView";
import Loader from "../../common/Loader";
import ModalAlert from "../../common/ModalAlert";
import { COLORS } from "../../constant";
import CButton from "../../common/CButton";
import applicationStyles from "../../styles/applicationStyles";
import { policyDetails } from "../../api/tripInsurance";
import moment from "moment";
import { isEmpty } from "lodash";
import useStyles from "./InsuranceOptions_Styles";
import CDocxViewer from "../../common/CDocxViewer";
export default function InsuranceOptions(props) {
  const styles = useStyles();
  const [loading, setLoading] = useState(false);
  const [policyInfo, setPolicyInfo] = useState({});
  const [policyStatus, setPolicyStatus] = useState(false);
  const [policyData, setPolicyData] = useState({});
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [tncModalVisible, setTncModalVisible] = useState(false);
  const [faqModalVisible, setFaqModalVisible] = useState(false)
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    navigate: "",
    actionButton: "",
  });


  const onCloseModal = () => {
    setAlertModalVisible(false);
    if (alertModal.navigate == "Dashboard") props.navigation.navigate("Home");
  };

  const getPolicyDetails = () => {
    policyDetails()
      .then((res) => {
        setLoading(false);
        if (res?.statusCode == 1097) {
          setLoading(false);
          setPolicyData(res?.data);
          if (res?.data != "" || res?.data != {}) {
            if (res?.data?.activePolicy) {
              setPolicyInfo(res?.data?.activePolicy);
              
              setPolicyStatus(true)
              return;
            }else if(res?.data?.expiredPolicy){
              setPolicyInfo(res?.data?.expiredPolicy);
              setPolicyStatus(true)
              return;
            }
            setPolicyInfo(res?.data?.recurringPolicyOpted);
            setPolicyStatus(false)
          } else {
            setLoading(false);
            setPolicyInfo({});
          }
        } else if (res?.statusCode == 500 || res?.statusCode < 0) {
          setAlertModalVisible(true);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res?.message,
            navigateScreen: "",
            actionButton: "OK",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        setAlertModalVisible(true);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err?.message,
          navigateScreen: "",
          actionButton: "OK",
        });
      });
  };

  useEffect(() => {
      getPolicyDetails();
  }, []);

  const onPressOptForInsurance = () => {
    if (isEmpty(policyData)) {
      props.setScreen("Benifits");
    } else {
      setAlertModalVisible(true);
      setAlertModal({
        title: "Error",
        status: "error",
        message: "You already opted a policy!",
        navigateScreen: "",
        actionButton: "OK",
      });
    }
  };

  const onCancelPress = () => {
    props.setScreen("CancelPolicy");
    props.setData({ ...props.data, ...{ policyData: policyData } });
  };

  const onClaimClick = () => {
    setAlertModalVisible(true)
    setAlertModal({
      title: "My Claims",
      status: "success",
      message:global.tripClaimContactInfo,
      navigateScreen: "",
      actionButton: "Go Back",
    })
  }

  const activePlanCard=()=>{
    return (
      <View style={styles.activePlanCard}>
      <CView FR P20 JS W100 style={styles.activePlanCardBg}>
        <View style={{ width: 160 }}>
          <CText.tripBenifitText style={styles.detailTxt}>
            Policy Number
          </CText.tripBenifitText>
          <CText.policyNbrText
            style={{ color: COLORS.white, fontSize: 12 }}
          >
            {policyInfo?.coiNo ? policyInfo?.coiNo : "N/A"}
          </CText.policyNbrText>
        </View>
        <CView>
          <CText.transactionText style={styles.statusBtn}>
          { policyStatus ? "Active" : "Opted"}
          </CText.transactionText>
        </CView>
      </CView>
      <CView FR JS W100 P20>
        <CView>
          <CText.tripBenifitText style={styles.detailTxt}>
            Policy Type
          </CText.tripBenifitText>
          <CText.policyNbrText style={{ color: COLORS.white }}>
            {policyInfo?.planName}{" "}
          </CText.policyNbrText>
        </CView>
        <CView>
          <CText.tripBenifitText style={styles.detailTxt}>
            {" "}
            Cover amount
          </CText.tripBenifitText>
          <CText.policyNbrText style={{ color: COLORS.white }}>
            {"₹" + policyInfo?.sumAssured}
          </CText.policyNbrText>
        </CView>
      </CView>
      <CView P20H>
        <CText.tripBenifitText style={styles.detailTxt}>
          {" "}
          Expiry Date
        </CText.tripBenifitText>
        <CText.policyNbrText style={{ color: COLORS.white }}>
          {policyInfo?.expiryDate
            ? moment(
                policyInfo?.expiryDate,
                "DDMMYYYYHHmmss"
              ).format("DD/MM/YYYY")
            : "N/A"}
        </CText.policyNbrText>
      </CView>
      <CButton
        title={"Cancel Policy"}
        onPress={() => onCancelPress()}
        style={styles.cancelBtn}
      />
    </View>
    )
  }
  const noActivePlanCard=()=>{
    return(
      <View style={styles.inActivePlanCard}>
      <CView AC JC>
        <CView style={styles.cir86}>
          <CImage.AlertIcon></CImage.AlertIcon>
        </CView>
        <CText.headerDesc style={applicationStyles.mt20}>
          You have no active insurance plans
        </CText.headerDesc>
        
        {/* <CText.transactionText>Get insured</CText.transactionText>
        <CButton
          onPress={() => {
            props.setScreen("Benifits");
          }}
          title={"Get insured"}
          style={applicationStyles.mt20}
        /> */}
      </CView>
      
    </View>
    )
  } 
  const insuranceWidget=()=>{
    return(
      <View style={styles.responsiveImgWidget}>
        {policyInfo && !_.isEmpty(policyInfo) ?
        <><TouchableOpacity onPress={onPressOptForInsurance} style={styles.optInsPicStyle}>
        <CImage.OptInsPic></CImage.OptInsPic>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => onClaimClick()} style={styles.certPicStyle}>
        <CImage.MyInsPic style={{ marginLeft: 14 }}></CImage.MyInsPic>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => {
          props.setScreen("Certificate");
          props.setData({
            ...props.data,
            ...{ policyData: policyData },
          });
        }}
        style={styles.claimInsPicStyle}
      >
        <CImage.ClaimInsPic></CImage.ClaimInsPic>
      </TouchableOpacity></> : 
      <>
     
                <TouchableOpacity onPress={() => onClaimClick()} style={styles.certPicStyle}>
                  <CImage.MyInsPic style={{ marginLeft: 14 }}></CImage.MyInsPic>
                </TouchableOpacity>
      </>}
                
              </View>
    )
  }
  const insuranceWidgetMobile=()=>{
    return(<View style={styles.responsiveImgWidgetMobile}>
      {policyInfo && !_.isEmpty(policyInfo) ?<>
        <TouchableOpacity onPress={onPressOptForInsurance} >
        <CImage.OptInsPicMobile></CImage.OptInsPicMobile>
      </TouchableOpacity>
      <TouchableOpacity onPress={() => onClaimClick()}>
        <CImage.MyInsPicMobile style={{ marginLeft: 14 }}></CImage.MyInsPicMobile>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => {
          props.setScreen("Certificate");
          props.setData({
            ...props.data,
            ...{ policyData: policyData },
          });
        }}
      >
        <CImage.ClaimInsPicMobile></CImage.ClaimInsPicMobile>
      </TouchableOpacity>
      </> :
        <TouchableOpacity onPress={() => onClaimClick()}>
          <CImage.MyInsPicMobile style={{ marginLeft: 14 }}></CImage.MyInsPicMobile>
        </TouchableOpacity>
      }
     
    </View>)
  }

  return (
    <View style={styles.mainContainer}>
      <View style={styles.titleWrapper}>
              <CText.basicInformationSubHeader style={{ fontSize: 18 }}>
                {'Trip Insurance'}
              </CText.basicInformationSubHeader>
        </View>
        <View style={styles.contentWrapper}>
        
          <View style={styles.responsiveWidget}>
            <View style={styles.leftPanel}>
              {insuranceWidget()}
              {insuranceWidgetMobile()}
              <CView MT={24} >
                <CText.basicInformationSubHeader>
                  Insurance Options
                </CText.basicInformationSubHeader>
                <CView FR MT={12} W100>
                  <View style={{flexDirection:'column',width:'25%',marginRight:20 }}>
                  <TouchableOpacity style={styles.iconCertificateStyle} onPress={() => setTncModalVisible(true)}>
                    <CImage.IconCertificate></CImage.IconCertificate>
                    </TouchableOpacity>
                    <CView AC style={{width:'100%',}}>
                    <TouchableOpacity onPress={() => setTncModalVisible(true)}>
                       <CText.certificateText style={{color:COLORS.orange}}>{"T&C"}</CText.certificateText>
                      </TouchableOpacity>
                  </CView>
                  </View>
                  <View style={{flexDirection:'column',width:'25%',marginRight:20}}>
                  <TouchableOpacity style={styles.iconTransactionStyle} onPress={() => props.setScreen("TransactionHistory")}>
                    <CImage.IconTransaction></CImage.IconTransaction>
                    </TouchableOpacity>
                    <CView AC style={{width:'100%',}}>
                    <TouchableOpacity onPress={() => props.setScreen("TransactionHistory")}>
                       <CText.transactionText style={{color:COLORS.navyBlue}}>Transactions</CText.transactionText>
                      </TouchableOpacity>
                  </CView>
                  </View>
                  <View style={{flexDirection:'column',width:'25%',marginRight:12,}}>
                  <TouchableOpacity
                    style={styles.iconHistoryStyle}
                    onPress={() => props.setScreen("DisputeHome")} >
                    <CImage.IconHistory></CImage.IconHistory>
                  </TouchableOpacity>
                  <CView AC style={{width:'100%',marginRight:12,}}>
                    <TouchableOpacity onPress={() => props.setScreen("DisputeHome")}>
                       <CText.transactionText style={{color:COLORS.gold}}>Disputes</CText.transactionText>
                      </TouchableOpacity>
                  </CView>
                  </View>
                 
                  
                </CView>
              </CView>
            </View>
            <View style={styles.activePlanCardWrapper}>
              <CText.basicInformationSubHeader> Active Plans </CText.basicInformationSubHeader>
              { policyInfo && !_.isEmpty(policyInfo) ? activePlanCard() : noActivePlanCard()}
            </View>
          </View>
          
      <View style={styles.tripInsRefTextWidget}>
        <CText.tripInsRefText> Reference no : {global.tripIsnpReferenceNo}</CText.tripInsRefText>
      </View>
          {loading && <Loader />}

          
        </View>
        {alertModalVisible && (
            <View style={styles.overlayViewStyle}>
              <ModalAlert
                title={alertModal.title}
                status={alertModal.status}
                message={alertModal.message}
                navigateScreen={alertModal.navigateScreen}
                actionButton={alertModal.actionButton}
                onCloseModal={onCloseModal}
              />
            </View>
          )}
    {tncModalVisible && <CDocxViewer type = "FF_TRIP_TNC" visibility={setTncModalVisible}/>}
    {faqModalVisible && <CDocxViewer type = "FF_TRIP_FAQ" visibility={setFaqModalVisible}/>}
          
        
    </View>
  );
}


